import { render, staticRenderFns } from "./ArticlesView.vue?vue&type=template&id=26750915&scoped=true&"
import script from "./ArticlesView.vue?vue&type=script&lang=ts&"
export * from "./ArticlesView.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlesView.vue?vue&type=style&index=0&id=26750915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26750915",
  null
  
)

export default component.exports